export default "__VITE_ASSET__q61gKEPi__"